/* assets/gmg-instock-first.js */
(() => {
  const STOREFRONT_TOKEN = "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";
  const API_VERSION = "2025-10"; // keep current; you can change later
  const ENDPOINT = `/api/${API_VERSION}/graphql.json`;

  const grid = document.getElementById("gmg-instock-grid");
  const loader = document.getElementById("gmg-instock-loader");
  if (!grid) return;

  const collectionHandle =
    grid.getAttribute("data-collection-handle") ||
    (window.ShopifyAnalytics &&
      window.ShopifyAnalytics.meta &&
      window.ShopifyAnalytics.meta.page &&
      window.ShopifyAnalytics.meta.page.collectionHandle) ||
    null;

  if (!collectionHandle) {
    console.warn("[GMG] No collection handle found.");
    if (loader) loader.style.display = "none";
    return;
  }

  if (!STOREFRONT_TOKEN || STOREFRONT_TOKEN.includes("PASTE_")) {
    console.warn("[GMG] Missing Storefront token.");
    if (loader) loader.style.display = "none";
    return;
  }

  // --- Minimal money formatter ---
  const formatMoney = (amountStr, currencyCode) => {
    const amount = Number(amountStr);
    if (!Number.isFinite(amount)) return "";
    try {
      return new Intl.NumberFormat(undefined, {
        style: "currency",
        currency: currencyCode || "USD",
        maximumFractionDigits: 2
      }).format(amount);
    } catch {
      return `${amount.toFixed(2)} ${currencyCode || ""}`.trim();
    }
  };

  const productCardHTML = (p) => {
    const url = `/products/${p.handle}`;
    const img = p.featuredImage?.url || "";
    const alt = p.featuredImage?.altText || p.title || "";
    const price = formatMoney(
      p.priceRange?.minVariantPrice?.amount,
      p.priceRange?.minVariantPrice?.currencyCode
    );

    const compare = p.compareAtPriceRange?.minVariantPrice?.amount
      ? formatMoney(
          p.compareAtPriceRange.minVariantPrice.amount,
          p.compareAtPriceRange.minVariantPrice.currencyCode
        )
      : null;

    // NOTE: Update classes/markup to match Stiletto cards if you want it pixel-perfect
    return `
      <div class="gmg-card" data-available="${p.availableForSale ? "true" : "false"}">
        <a class="gmg-card__link" href="${url}">
          <div class="gmg-card__media">
            ${img ? `<img loading="lazy" src="${img}" alt="${alt.replace(/"/g, "&quot;")}" />` : ""}
          </div>
          <div class="gmg-card__body">
            <div class="gmg-card__title">${p.title || ""}</div>
            <div class="gmg-card__price">
              ${compare ? `<span class="gmg-card__compare">${compare}</span>` : ""}
              <span class="gmg-card__current">${price}</span>
            </div>
          </div>
        </a>
      </div>
    `;
  };

  // Simple grid styling (you can delete if you’ll map to theme classes)
  const injectBasicStyles = () => {
    const style = document.createElement("style");
    style.textContent = `
      #gmg-instock-grid{
        display:grid;
        grid-template-columns: repeat(3, minmax(0, 1fr));
        gap: 28px;
      }
      @media (max-width: 1024px){ #gmg-instock-grid{ grid-template-columns: repeat(2, minmax(0, 1fr)); } }
      @media (max-width: 640px){  #gmg-instock-grid{ grid-template-columns: repeat(1, minmax(0, 1fr)); } }
      .gmg-card__media img{ width:100%; height:auto; display:block; }
      .gmg-card__title{ margin-top:10px; font-size:16px; line-height:1.3; }
      .gmg-card__price{ margin-top:6px; font-size:14px; }
      .gmg-card__compare{ text-decoration:line-through; opacity:.6; margin-right:8px; }
      .gmg-card__link{ text-decoration:none; color:inherit; display:block; }
    `;
    document.head.appendChild(style);
  };

  const gql = async (query, variables) => {
    const res = await fetch(ENDPOINT, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "X-Shopify-Storefront-Access-Token": STOREFRONT_TOKEN
      },
      body: JSON.stringify({ query, variables })
    });

    if (!res.ok) {
      const text = await res.text();
      throw new Error(`Storefront API error: ${res.status} ${text}`);
    }

    const json = await res.json();
    if (json.errors && json.errors.length) {
      throw new Error(json.errors.map(e => e.message).join(" | "));
    }
    return json.data;
  };

  const QUERY = `
    query ProductsByAvailability($handle: String!, $first: Int!, $after: String, $available: Boolean!) {
      collection(handle: $handle) {
        products(
          first: $first,
          after: $after,
          sortKey: COLLECTION_DEFAULT,
          filters: [{ available: $available }]
        ) {
          pageInfo { hasNextPage endCursor }
          nodes {
            id
            handle
            title
            availableForSale
            featuredImage { url altText }
            priceRange { minVariantPrice { amount currencyCode } }
            compareAtPriceRange { minVariantPrice { amount currencyCode } }
          }
        }
      }
    }
  `;

  const fetchAll = async (availableBool) => {
    const all = [];
    let after = null;

    while (true) {
      const data = await gql(QUERY, {
        handle: collectionHandle,
        first: 100,
        after,
        available: availableBool
      });

      const conn = data?.collection?.products;
      if (!conn) break;

      all.push(...(conn.nodes || []));

      if (!conn.pageInfo?.hasNextPage) break;
      after = conn.pageInfo.endCursor;
      if (!after) break;
    }

    return all;
  };

  const run = async () => {
    injectBasicStyles();

    try {
      // 1) In-stock first
      const inStock = await fetchAll(true);
      grid.insertAdjacentHTML("beforeend", inStock.map(productCardHTML).join(""));

      // 2) Out-of-stock after
      const outStock = await fetchAll(false);
      grid.insertAdjacentHTML("beforeend", outStock.map(productCardHTML).join(""));

      if (loader) loader.style.display = "none";
      console.log(`[GMG] Rendered ${inStock.length} in-stock + ${outStock.length} out-of-stock`);
    } catch (err) {
      console.error("[GMG] Failed:", err);
      if (loader) loader.textContent = "Failed to load products.";
    }
  };

  run();
})();
